import React, { useContext, useEffect, useState } from 'react'
import { PopupContext } from '../LoginPopup/LoginPopupContext';
import StringToHtml from '../../StringToHtml';

function MobileLiveStreamTab({ matchStatus, evId, spId, receivedBetlistData,url,tvUrl ,width}) {
  const [tabActive, setTabactive] = useState(matchStatus == "IN_PLAY" || spId == "4" || spId == "4339" ? 'tab3':'tab1');
  const [liveStreamSlide, setLiveStreamSlide] = useState('open');
  const { loggedIn } = useContext(PopupContext);
  const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem('loggedIn'));
  const [betLoginShow, setBetLoginShow] = useState();

  useEffect(() => {
    // console.log(spId,"spIdspIdspIdspIdspId");
    
    if(isLoggedIn || loggedIn){
      setBetLoginShow(true)
    }else{
      setBetLoginShow(false)
    }
  }, [loggedIn, isLoggedIn, betLoginShow,url,tvUrl])

  const tabHandle = (name) => {
    setTabactive(name)
  }
  const liveStreamHandle = () => {
    setLiveStreamSlide(!liveStreamSlide)
  }

  const getIframe = (url) => {
    return <StringToHtml htmlString={url}  />
  }
   const liveStreamfunction = (width) => {
  // console.log("asfasfsgdsdgrgfdgdfgg");
  
            let user = sessionStorage.getItem('userinfo');
            if (user == null) {
                return false;
            }else{
                let usera = JSON.parse(user);
                if(width > 767){
                        return false;
                    }else{
                        if (usera.roleName == "DemoLogin"){
                            return false;
                        }else{
                            return true;
                        }
                    }
            }
        }

  const getSportName = (spId) => {
    if(spId == '4'){
      return 'cricket'
    }else if(spId == '2'){
      return 'tennis'
    }else if(spId == '1'){
      return 'soccer'
    }
  }

  // console.log('receivedBetlistDatareceivedBetlistDataere', receivedBetlistData);
  return (
    <div className='live-stream-mobile-tab'>
      <div className='live-stream-tab-btns'>
        
          <button className={`btn ${tabActive === 'tab1' ? 'active' : ''}`} onClick={() => tabHandle('tab1')}>Score</button>
        

        {liveStreamfunction(width) ? 
          <button className={`btn ${tabActive === 'tab2' ? 'active' : ''}`} onClick={() => tabHandle('tab2')}>Live Stream</button>
        : '' }

        <button className={`btn ${tabActive === 'tab3' ? 'active' : ''}`} onClick={() => tabHandle("tab3")}>Bets ({receivedBetlistData?.length})</button>
      </div>
      <div className='live-stream-tab-content'>
        <div className={`live-stream-tab-panel score-card ${tabActive === 'tab1' ? 'active' : ''}`}>

        { url ? getIframe(url) :<iframe src={`https://scorebae.com/sportslive/sbscore/${getSportName(spId)}/${evId}`} width="100%"></iframe>}
          
        </div>
        <div className={`live-stream-tab-panel tv-view ${tabActive === 'tab2' && liveStreamfunction(width) ? 'active' : ''}`}>
          <div className='live-stream'>
            <div className='title live-stream-title' onClick={liveStreamHandle}>Live Stream</div>
            <div className={`livestream-iframe ${liveStreamSlide && liveStreamSlide ? 'open' : ''}`}>
            { width < 767 && liveStreamfunction(width) ? tvUrl && evId ? getIframe(tvUrl) : '' :''}
            </div>
          </div>
        </div>
        <div className={`live-stream-tab-panel betlist-view ${tabActive === 'tab3' ? 'active' : ''}`}>
          <div className='title'>Open Bets ({receivedBetlistData?.length})</div>
          <div className='betlist'>
            {betLoginShow ?
            <table className="betlist-table">
              <thead>
                <tr>
                  <th>Selection</th>
                  <th>Odds</th>
                  <th>Market</th>
                  <th>Stake</th>
                </tr>
              </thead>
              <tbody>
                {receivedBetlistData?.map((item, index) => (
                  <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}`}>
                    <td> {item?.selectionName}</td>
                    <td> {item?.oddValue}</td>
                    <td> {item?.marketName}</td>
                    <td> {item?.Stake}</td>
                  </tr>
                ))}
              </tbody>
            </table> : ''}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileLiveStreamTab